import type { Ref } from 'vue';
import type { RouteLocationNamedRaw } from 'vue-router';
import {
  computed,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { ADMIN_ROUTE_NAME, AFFILIATE_ROUTE_NAME } from '@modules/core/services/router/constants';

export interface NamespaceRoutesComposable {
  isAffiliateRoute: Ref<boolean>;
  isAdminRoute: Ref<boolean>;
  isCurrentRouteChildOf(parentRoute: RouteLocationNamedRaw): boolean;
}

export default function useNamespaceRoutes(): NamespaceRoutesComposable {
  const router = useRouter();
  const route = useRoute();

  function isCurrentRouteChildOf(parentRoute: RouteLocationNamedRaw): boolean {
    return route.matched.some((val) => router.resolve(val).path === router.resolve(parentRoute).path);
  }

  const isAffiliateRoute = computed<boolean>(() => isCurrentRouteChildOf({ name: AFFILIATE_ROUTE_NAME }));

  const isAdminRoute = computed<boolean>(() => isCurrentRouteChildOf({ name: ADMIN_ROUTE_NAME }));

  return {
    isAffiliateRoute,
    isAdminRoute,
    isCurrentRouteChildOf,
  };
}
